import { Issue } from "@adsk/acc-issues-types";
import { getCurrentUserIsAdminValue } from "@adsk/acc-issues-core/state/redux/ducks/currentUserPermissions";
import { useSelector } from "@adsk/acc-issues-core/state/redux/hooks";
import { useUser } from "@adsk/acc-issues-core/utils/hooks/alloyHooks";
import {
  FeatureFlag,
  useFeatureFlag,
} from "@adsk/acc-issues-core/utils/featureFlags";
import { shouldWarnBeforeUnpublish } from "../utils/data/issueVisibilityUtils";

export const useShouldWarnBeforeUnpublish = (issues: Issue[]): boolean => {
  const { user: currentUser } = useUser();
  const isProjectAdmin = useSelector(getCurrentUserIsAdminValue);
  const { value: adminsCanViewUnpublished } = useFeatureFlag(
    FeatureFlag.AdminsCanViewUnpublishedIssues
  );

  return shouldWarnBeforeUnpublish({
    userOxygenId: (currentUser && currentUser.autodeskId) || null,
    canViewUnpublishedIssues: isProjectAdmin && !!adminsCanViewUnpublished,
    issues,
  });
};
